import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  ApiResponse,
  Subject,
  CreateSubjectRequest,
  GetSubjectsParams,
  UpdateSubjectRequest,
} from "@/types/subjectTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const subjectApi = createApi({
  reducerPath: "subjectApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Subject"],
  endpoints: (builder) => ({
    createSubject: builder.mutation<ApiResponse<Subject>, CreateSubjectRequest>({
      query: (data) => ({
        url: "/subject",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Subject"],
    }),
    getAllSubjects: builder.query<ApiResponse<Subject[]>, GetSubjectsParams | void>({
      query: (params) => ({
        url: "/subject",
        params: params || undefined,
      }),
      providesTags: ["Subject"],
    }),
    getSubjectById: builder.query<ApiResponse<Subject>, string>({
      query: (id) => `/subject/${id}`,
      providesTags: ["Subject"],
    }),
    updateSubject: builder.mutation<ApiResponse<Subject>, UpdateSubjectRequest>({
      query: ({ id, ...data }) => ({
        url: `/subject/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Subject"],
    }),
    deleteSubject: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/subject/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Subject"],
    }),
  }),
});

export const {
  useCreateSubjectMutation,
  useGetAllSubjectsQuery,
  useGetSubjectByIdQuery,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
} = subjectApi;
